import type {
  DeviceLogResourceListResponseApi,
  SearchDeviceLogV2QueryParamsApi,
  SearchRequestApi,
} from '@ingenico/api-sdk-device-management-private-v2';
import type { BusinessServiceRequestWithFirstQueryLoading } from '@ingenico/react-section-utils';
import { useBusinessServiceRequestWithFirstQueryLoading } from '@ingenico/react-section-utils';
import { useCallback, useEffect, useState } from 'react';
import { DeviceManagementService } from '../domain/business/services/deviceManagement.service';

interface GetDeviceLogsByIdV2Props {
  readonly deviceId: string;
  readonly shouldFetch?: boolean;
  readonly body: SearchRequestApi;
  readonly params?: SearchDeviceLogV2QueryParamsApi;
}

export function useGetDeviceLogsByIdV2({
  deviceId,
  shouldFetch = true,
  body,
  params,
}: GetDeviceLogsByIdV2Props): BusinessServiceRequestWithFirstQueryLoading<DeviceLogResourceListResponseApi> {
  const [canFetchAfterPermission, setCanFetchAfterPermission] = useState(shouldFetch);

  useEffect(() => {
    if (shouldFetch && !canFetchAfterPermission) {
      setCanFetchAfterPermission(true);
    }
  }, [canFetchAfterPermission, shouldFetch]);

  return useBusinessServiceRequestWithFirstQueryLoading(
    DeviceManagementService,
    useCallback(
      (deviceManagementService) => {
        return canFetchAfterPermission ? deviceManagementService.getDeviceLogsByIdV2({ deviceId, body, params }) : null;
      },
      [body, deviceId, params, canFetchAfterPermission],
    ),
  );
}
